import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider';
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from 'react-bootstrap';
import corporateAccountImage from "../../assets/static/business/loan_proof_of_income.png";

function CorperateAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Corperate Account? We’ve got you covered." 
        description="Kontriman offers various ways to support your Corperate Account – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere." 
        imageUrl={FlightImage}
    />
     <div>
      <Container fluid className="my-5 bg-custom">
        <Container className='container-padding'>
          <Row className="flex-column flex-md-row">
            {/* Image column */}
            <Col md={6} className="order-2 order-md-1">
              <img
                src={corporateAccountImage}
                alt="Corporate Account"
                className="img-fluid"
              />
            </Col>

            {/* Text column */}
            <Col md={6} className="d-flex align-items-center order-1 order-md-2">
              <div>
                <h1 className='custom_heading'>Corporate Account with Kontriman</h1>
                <p>
                  Tailored for large enterprises and organizations, Kontriman’s Corporate Account offers comprehensive banking solutions to streamline your financial management.
                </p>
                <p>
                  Enjoy enhanced transaction limits, multi-user access with role-based permissions, and specialized support from our corporate banking team. Manage payroll, vendor payments, and cash flow efficiently with our secure platform.
                </p>
                <p><strong>Benefits include:</strong></p>
                <ul>
                  <li>High transaction and deposit limits</li>
                  <li>Multi-user access with customizable roles</li>
                  <li>Dedicated corporate relationship managers</li>
                  <li>Integrated online and mobile banking</li>
                  <li>Customized reporting and analytics</li>
                </ul>

                <a href="/login">
                  <Button className='custom-button mt-3'>Open a Corporate Account</Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
      <Footer></Footer>
    </div>
  );
}

export default CorperateAccount;
